"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PiwikLogger = /** @class */ (function () {
    function PiwikLogger(options) {
        this.options = options;
        this.handler = window._paq;
    }
    PiwikLogger.prototype.increment = function (name, delta) {
        this.handler.push(['trackEvent', this.options.prefix, '', name, delta]);
    };
    PiwikLogger.prototype.gauge = function (name, value) {
        this.handler.push(['trackEvent', this.options.prefix, '', name, value]);
    };
    PiwikLogger.prototype.timing = function (name, date) {
        var time = this.calculateTimeDifference(date, new Date());
        this.handler.push(['trackEvent', this.options.prefix, '', name, time]);
    };
    PiwikLogger.prototype.calculateTimeDifference = function (end, time) {
        return time.getTime() - end.getTime();
    };
    return PiwikLogger;
}());
exports.PiwikLogger = PiwikLogger;
//# sourceMappingURL=PiwikLogger.js.map